import React, { useState } from "react"

type DataSyncInfoProps = {
  isVisible: boolean
}

const DataSyncInfo: React.FC<DataSyncInfoProps> = ({ isVisible }) => {
  const [isInfoExpanded, setIsInfoExpanded] = useState(false)

  if (!isVisible) {
    return null
  }

  return (
    <div className="mb-6">
      <button
        onClick={() => setIsInfoExpanded(!isInfoExpanded)}
        className="w-full text-left flex flex-col items-center justify-between bg-system-blue-800 border border-system-blue-700 rounded-system-xl p-4 transition-colors"
      >
        <div className="flex items-center justify-between w-full">
          <span className="text-base text-white font-bold">
            Just a heads up:
          </span>
          <svg
            className={`w-5 h-5 text-gray-300 transition-transform duration-200 ${
              isInfoExpanded ? "rotate-180" : ""
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>

        {isInfoExpanded && (
          <div className="pt-2 text-base text-gray-300 leading-relaxed">
            <p>
              We're processing your data as fast as possible, but each platform
              we connect to has its own limits on data volume and speed. For
              most accounts, syncing takes 1–2 days, but larger datasets can
              take up to a week.
            </p>
            <br />
            <p>
              Once your key connectors are in place, we'll begin building your
              Customer Brand Model — a process that involves analyzing your data
              and may take a few more days to complete.
            </p>
            <br />
            <p>
              In the meantime, feel free to add more connections and explore
              keyword options to enrich your model.
            </p>
            <br />
            <p>
              We'll notify you as soon as everything's ready. Thanks for your
              patience — we're excited to help you build a more resilient
              revenue foundation!
            </p>
          </div>
        )}
      </button>
    </div>
  )
}

export default DataSyncInfo
